// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo__1WUr8","trim":"trim__10ZUh"};


//////////////////
// WEBPACK FOOTER
// ./components/Logo/style.css
// module id = h0Qy
// module chunks = 0